import axios from 'axios';
import { config } from '../../../../config/envs';

const ADMIN_BASE_URL = config.app.adminBaseUrl;

export class UserAccessControlAPI {
  static async block(payload) {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/user-access-control/block`,
      payload,
    );
    return response;
  }

  static async unblock(clientId) {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/user-access-control/unblock`,
      { clientId },
    );
    return response;
  }
}
